export default __webpack_public_path__ + "static/media/026-wooden-leg.39a8771d.png";